import { ArrowRight, Check, Clock, FileSignature } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { PORTAL_ROUTES } from "utils/constants"
import StatusBadge from "components/StatusBadge"
import { canOpenStep, getStepIndex } from "pages/Profile/helper"

const Item = ({ item, completion, pendingCount = 0 }) => {
  const navigate = useNavigate();
  let { title, description, id, time } = item || {}
  let isCompleted = completion[id]
  let isDisabled = !canOpenStep(getStepIndex(id), completion)

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={() => navigate(`${PORTAL_ROUTES.PROFILE}/${id}`)}
      className={`group w-full text-left border rounded-2xl p-5 flex flex-col gap-3 transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 ${pendingCount ? "border-amber-200" : "border-gray-100"} ${isDisabled ? "bg-gray-100 grayscale opacity-60 pointer-events-none" : "bg-white cursor-pointer hover:shadow-sm"}`}
    >
      <p className="font-semibold text-secondary-900">{title}</p>

      <div className="flex flex-wrap items-center gap-2">
        <StatusBadge
          status={isCompleted ? "Complete" : "Pending"}
          className={isCompleted ? "bg-success-50 text-green-700 border-green-200" : "bg-primary-50 text-primary-700 border-primary-200"}
          icon={isCompleted ? Check : Clock}
        />

        {pendingCount > 0 && (
          <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700">
            <FileSignature size={13} strokeWidth={2.5} />
            {pendingCount} treatment {pendingCount === 1 ? 'consent' : 'consents'} pending
          </span>
        )}
      </div>

      <p className="text-sm text-secondary-400 mt-0.5">{description}</p>

      <div className="flex items-center justify-between mt-auto pt-1 w-full">
        <span className="inline-flex items-center gap-1 text-sm font-semibold transition-colors text-secondary-900 group-hover:text-secondary-600">
          {isCompleted ? 'View & edit' : 'Start'}
          <ArrowRight size={14} />
        </span>
        <span className="text-xs text-secondary-400">{time}</span>
      </div>
    </button>
  )
}

export default Item
